var path = 'services/success-toast.tpl.html';
var html = " <md-toast class=tb-success-toast> <div class=md-toast-content> <div class=md-toast-text ng-bind-html=vm.message></div> <md-button ng-click=vm.closeToast()> {{ 'action.close' | translate }} </md-button> </div> </md-toast> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/services/success-toast.tpl.html
// module id = 1520
// module chunks = 1